import React from 'react';
import { useTranslation } from 'react-i18next';

import { UserCounter } from 'libs/steps/src/lib/collectors/components/user-counter';

import { Wrapper } from '../../../components/Wrapper';
import { InterfaceWrapper } from '../../../components/InterfaceWrapper';
import { PlayerInterface } from './PlayerInterface';
import { usePresenterActions } from '../../../utils/use-presenter-actions';

export const NameYourShip = InterfaceWrapper({
  Interface: PlayerInterface,
  Step: ({ data }) => {
    const { t } = useTranslation();

    const { actions } = usePresenterActions(data);

    return (
      <Wrapper>
        <h1>{t('fishery.selectNameTitlePresentation')}</h1>
        <UserCounter actions={actions} />
      </Wrapper>
    );
  },
});
